import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StoreProvider } from "@/context/StoreContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Product from "@/components/Product";
import Ingredients from "@/components/Ingredients";
import Usage from "@/components/Usage";
import Reviews from "@/components/Reviews";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AdminMessages from "@/pages/AdminMessages";

const Shop = () => (
  <>
    <Header />
    <main>
      <Hero />
      <TrustBar />
      <Product />
      <Ingredients />
      <Usage />
      <Reviews />
      <FAQ />
      <Contact />
      <Newsletter />
    </main>
    <Footer />
    <CartDrawer />
  </>
);

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Shop />} />
            <Route path="/admin/berichten" element={<AdminMessages />} />
          </Routes>
        </div>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
